import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/icons/calculator-fill.svg'


const _withScopeId = n => (_pushScopeId("data-v-1a3c5128"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-12 p-4 section-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Find out how much you can borrow from the banks", -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "calculate-icon",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Free Loan Calculator ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.85em","color":"gray","padding":"5px auto","text-align":"center","margin-top":"10px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "*No registration required. No personal details asked.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.toolLoanEligibilityCalculatorUrl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("a", {
            type: "button",
            class: "btn",
            target: "_blank",
            style: {"margin-top":"15px"},
            href: _ctx.toolLoanEligibilityCalculatorUrl
          }, _hoisted_7, 8, _hoisted_4),
          _hoisted_8
        ])
      ]))
    : _createCommentVNode("", true)
}